import React from "react";
import { Modal, Slide, IconButton } from "@material-ui/core";
import { ThemeType } from "@theme";
import { CloseIcon } from "@bonliva-crm/ui";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  open?: boolean;
  children: React.ReactNode;
  onClose: () => any;
  offsetLevel?: number;
  navigationName: string;
};

export function ModalSlider(props: Props) {
  const { children, offsetLevel = 0, onClose } = props;

  const isConsultantSlider = props.navigationName.includes("consultantSlider");

  const classes = useStyles({ isConsultantSlider });

  const handleClose = (e) => {
    if (e.defaultPrevented) {
      return;
    }

    onClose && onClose();
  };

  const open = typeof props.open === "boolean" ? props.open : Boolean(children);

  const style: React.CSSProperties = {
    // position: "relative",
    left: 48 * offsetLevel,
    paddingRight: 48 * offsetLevel
  };

  return (
    <Modal className={classes.modalRoot} open={open} onClose={handleClose}>
      <>
        {isConsultantSlider && (
          <Slide direction="left" in={open}>
            <IconButton className={classes.closeButton} onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Slide>
        )}

        <Slide direction="left" in={open}>
          <div
            className={classes.modalContent}
            data-test="ModalSlider"
            id="modal-slider-container"
            tabIndex={-1}
            style={style}
            data-offset={offsetLevel}
          >
            {children}
          </div>
        </Slide>
      </>
    </Modal>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  modalRoot: (props: { isConsultantSlider: boolean }) => ({
    justifyContent: "flex-end",
    display: "flex",
    paddingLeft: props.isConsultantSlider ? "3.5rem" : undefined
  }),

  modalContent: (props: { isConsultantSlider: boolean }) => ({
    background: theme.palette.background.default,
    flex: "0 0 100%",
    overflowX: "hidden",
    overflowY: "auto",

    [theme.breakpoints.up("md")]: {
      flexBasis: props.isConsultantSlider ? "100%" : "calc(100px + 80%)"
    },

    [theme.breakpoints.up("lg")]: {
      flexBasis: props.isConsultantSlider ? "100%" : "calc(100px + 80%)"
    }
  }),
  closeButton: {
    backgroundColor: theme.palette.background.default,
    height: "38px",
    width: "38px",
    borderRadius: "50%",
    margin: "8px",
    "&:hover": {
      backgroundColor: theme.palette.background.default
    }
  }
}));
